import { FC, ReactNode } from "react";

import { VnBox } from "@/components/VnBox";
import { VnCard } from "@/components/VnCard";
import { VnText, VnTextPropsType } from "@/components/VnText/VnText";

type DashboardCompactCardPropsType = Pick<
  VnTextPropsType,
  "i18nKey" | "i18nOptions" | "children"
> & {
  actions: ReactNode;
};

// Secondary "next step" card: a short message with its action(s) on the side.
//
// When the actions don't fit beside the message at its minimum readable width
// (narrow phones, longer translations), they wrap below it instead of
// squeezing the text. The 999:1 grow ratio keeps the actions at their natural
// width while they share the row, yet lets them span the card once wrapped.
export const DashboardCompactCard: FC<DashboardCompactCardPropsType> = ({
  i18nKey,
  i18nOptions,
  children,
  actions,
}) => (
  <VnCard className="flex flex-row flex-wrap items-center gap-3 md:gap-4">
    <VnText
      variant="lg"
      className="min-w-36 flex-[999]"
      i18nKey={i18nKey}
      i18nOptions={i18nOptions}>
      {children}
    </VnText>

    <VnBox className="grow gap-2">{actions}</VnBox>
  </VnCard>
);
